import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { MailWarning, X } from "lucide-react";

export function VerifyBanner() {
    const { user } = useAuth();
    const [dismissed, setDismissed] = useState(false);
    const [sent, setSent] = useState(false);

    if (!user || user.email_verified || dismissed) return null;

    const resend = async () => {
        try {
            await api.post("/auth/resend-verification", { email: user.email });
            setSent(true);
        } catch (e) {}
    };

    return (
        <div className="bg-[#0A44E6] text-white" data-testid="verify-banner">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 text-sm">
                <MailWarning size={16} className="shrink-0" />
                <p className="flex-1 leading-snug">
                    Please confirm your email to join the mailing list.{" "}
                    {sent ? (
                        <span className="font-semibold" data-testid="verify-resent">Confirmation link sent — check your inbox.</span>
                    ) : (
                        <button onClick={resend} data-testid="verify-resend" className="underline font-semibold hover:text-white/80">
                            Resend confirmation link
                        </button>
                    )}
                </p>
                <button onClick={() => setDismissed(true)} aria-label="Dismiss" className="shrink-0 hover:text-white/70">
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
